import React, { useState } from 'react'
import Constants from '../../../constants'
import ProductForm from '../components/form'
import DirectSaleProductService from '../../../services/DirectSaleProductService'
import { DirectSaleProduct } from '../../../interfaces/directSaleProduct'
import { ProjectContainer } from '../../../components/project-container'
import { Link, useNavigate } from 'react-router-dom'
import { Loader } from '../../../components/loader'
import './index.scss'
import { PageHeader } from '../../../components/page-header'
import { Button } from 'components/button'
import { Snackbar } from 'components/snackbar'
import SnackBarSuccessStyle from 'styles/snackbar-success.style'
import { useSnackbar } from 'react-simple-snackbar'
import { useContext } from 'react'
import { UserContext } from 'contexts/user'
import ButtonV3 from 'components/Buttonv3'

import { ImArrowLeft2 } from 'react-icons/im'
import { PageHeaderV2 } from 'components/pageHeaderV2'

const ProductAdd = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [openSnackbar] = useSnackbar(SnackBarSuccessStyle)
    const navigate = useNavigate()
    const { user } = useContext(UserContext)

    const save = (product: DirectSaleProduct, levels: number[]) => {
        setLoading(true)
        DirectSaleProductService.add(product, levels, user.providerId)
            .then(() => {
                setLoading(false)
                navigate(Constants.ROUTE_PRODUCTS)
                openSnackbar(
                    <Snackbar icon="sticky_note_2">
                        Produto salvo com sucesso!
                    </Snackbar>
                )
            })
            .catch((error) => {
                openSnackbar(
                    <Snackbar icon="sticky_note_2">
                        {error.response && error.response.data
                            ? error.response.data.mensagem
                            : 'Ocorreu um erro ao salvar o produto!'}
                    </Snackbar>
                )
                setLoading(false)
            })
    }

    const submit_form = () => {
        const sub_btn = document.getElementById('save-product')
        if (sub_btn) {
            sub_btn.click()
        }
    }

    return (
        <ProjectContainer>
            <div className="products-add">
                {loading && <Loader />}
                <header style={{ marginBottom: 25 }}>
                    <PageHeaderV2 title="Adicionar Produto" />
                </header>

                <div className="form">
                    <ProductForm
                        saveCallback={(
                            product: DirectSaleProduct,
                            levels: number[]
                        ) => save(product, levels)}
                    />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            gap: 20,
                            marginTop: 25,
                        }}
                    >
                        <Link to={Constants.ROUTE_PRODUCTS}>
                            <ButtonV3
                                Icon={<ImArrowLeft2 className="iconButtonV3" />}
                                style={{ padding: '6px 35px', height: 45 }}
                                title="Voltar"
                                type="button"
                                onClick={submit_form}
                            />
                            {
                                //   <Button>
                                //       <i className="material-icons">arrow_back</i>Voltar
                                //   </Button>
                            }
                        </Link>
                        {
                            //     <Button
                            //         type="submit"
                            //         className="c-btn-save ml-3"
                            //         onClick={submit_form}>
                            //         <i className="material-icons">save_alt</i>Salvar
                            //     </Button>
                        }
                        <ButtonV3
                            filled
                            style={{ padding: '6px 35px', height: 45 }}
                            title="Salvar"
                            type="submit"
                            onClick={submit_form}
                        />
                    </div>
                </div>
            </div>
        </ProjectContainer>
    )
}

export default ProductAdd
